import React, { createContext, useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";

// Crea el contexto
export const GlobalContext = createContext();
// Crea el proveedor del contexto
export const GlobalContextProvider = ({ children }) => {
  const { accounts } = useMsal();
  const [context, setContext] = useState({
    page: "listPrint",
    selectedTicket: {},
    currentUser: null
  });

  useEffect(() => {
    if (accounts.length > 0) {
      setContext(prev => ({
        ...prev,
        currentUser: {
          username: accounts[0].username,
          name: accounts[0].name,
          email: accounts[0].username
        }
      }));
    }
  }, [accounts]);

  return (
    <GlobalContext.Provider value={{ context, setContext }}>
      {children}
    </GlobalContext.Provider>
  );
};
